import { ApplicationState } from '../reducers';
import { ApplicationSpinnerState } from 'ts/types/application-spinner.types';

export const applicationSpinnerSelector = (
  state: ApplicationState,
): ApplicationSpinnerState => state.applicationSpinner;
